<template>
  <LoadingIcon
    v-if="isLoading"
  />

  <button
    v-else
    class="playlist-toggle__button"
    :class="{'playlist-toggle__button--active' : isActiveFake}"
    @click="togglePlaylist"
  >
    <svg viewBox="0 0 512 512" >
       <path d="M376,30c-27.783,0-53.255,8.804-75.707,26.168c-21.525,16.647-35.856,37.85-44.293,53.268
        c-8.437-15.419-22.768-36.621-44.293-53.268C189.255,38.804,163.783,30,136,30C58.468,30,0,93.417,0,177.514
        c0,90.854,72.943,153.015,183.369,247.118c18.752,15.981,40.007,34.095,62.099,53.414C248.38,480.596,252.12,482,256,482
        s7.62-1.404,10.532-3.953c22.094-19.322,43.348-37.435,62.111-53.425C439.057,330.529,512,268.368,512,177.514
        C512,93.417,453.532,30,376,30z"/>
    </svg>
    <span
      v-if="!isActiveFake"
    >Salvar</span>
    <span
      v-else
    >Favorito</span>
  </button>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      LoadingIcon,
    },

    props: {
      courseId: { type: Number, default: null }
    },

    data: () => ({
      isLoading: true,
      isLoadingQuietly: false,
      isActiveFake: false
    }),

    async mounted () {
      this.isLoading = true

      await this.fetchUserPlaylistDefault()
      this.isActiveFake = this.isActive

      this.isLoading = false
    },

    computed: {
      ...mapGetters('playlist', [
        'playlistDefaultCourseByCourseId'
      ]),

      isActive () {
        return !!this.playlistCourse
      },

      playlistCourse () {
        return this.playlistDefaultCourseByCourseId(this.courseId)
      }
    },

    watch: {
      isActive (isActive) {
        this.isActiveFake = isActive
      }
    },

    methods: {
      ...mapActions('playlist', [
        'fetchUserPlaylistDefault',
        'removeUserPlaylistDefaultCourse',
        'createUserPlaylistDefaultCourse'
      ]),

      async togglePlaylist () {
        if (this.isLoadingQuietly) {
          return null
        }

        this.isActiveFake = !this.isActiveFake
        this.isLoadingQuietly = true

        if (this.isActive) {
          await this.removeUserPlaylistDefaultCourse(this.playlistCourse.id)
        } else {
          await this.createUserPlaylistDefaultCourse(this.courseId)
        }

        this.isLoadingQuietly = false
      },
    },
  }
</script>

<style scoped lang="scss">
  .playlist-toggle {
    &__button {
      padding: 6px 0;
      width: 160px;
      border: 2px solid rgba(#000, .75);
      border-radius: 5rem;

      svg {
        width: 20px;
        fill: lighten(#000, 20%);
        margin-right: 5px
      }

      span {
        width: 70px;
        font-size: 13px;
        font-weight: 400;
        color: lighten(#000, 20%);
        font-weight: 600;
        text-transform: uppercase;
      }

      &--active {
        @extend .playlist-toggle__button;

        border-color: #ff8800;

        svg { fill: #ff8800 }

        span { color: #ff8800 }
      }
    }
  }
</style>